export default {
  'app.setting.pagestyle': 'Cài đặt giao diện',
  'app.setting.pagestyle.dark': 'Giao diện tối',
  'app.setting.pagestyle.light': 'Giao diện sáng',
  'app.setting.content-width': 'Độ rộng nội dung',
  'app.setting.content-width.fixed': 'Cố định',
  'app.setting.content-width.fluid': 'Tự động',
  'app.setting.themecolor': 'Màu chủ đạo',
  'app.setting.themecolor.dust': 'Đỏ bụi',
  'app.setting.themecolor.volcano': 'Cam núi lửa',
  'app.setting.themecolor.sunset': 'Cam hoàng hôn',
  'app.setting.themecolor.cyan': 'Xanh lục lam',
  'app.setting.themecolor.green': 'Xanh lá',
  'app.setting.themecolor.daybreak': 'Xanh dương (mặc định)',
  'app.setting.themecolor.geekblue': 'Xanh geek',
  'app.setting.themecolor.purple': 'Tím hoàng kim',
  'app.setting.navigationmode': 'Chế độ điều hướng',
  'app.setting.sidemenu': 'Menu bên',
  'app.setting.topmenu': 'Menu trên',
  'app.setting.fixedheader': 'Cố định Header',
  'app.setting.fixedsidebar': 'Cố định Sidebar',
  'app.setting.fixedsidebar.hint': 'Hoạt động với Menu bên',
  'app.setting.hideheader': 'Ẩn Header khi cuộn',
  'app.setting.hideheader.hint': 'Hoạt động khi bật ẩn Header',
  'app.setting.othersettings': 'Cài đặt khác',
  'app.setting.weakmode': 'Chế độ hỗ trợ màu',
  'app.setting.copy': 'Sao chép cài đặt',
  'app.setting.copyinfo':
    'Sao chép thành công, vui lòng thay thế defaultSettings trong src/models/setting.js',
  'app.setting.production.hint':
    'Bảng cài đặt chỉ hiển thị trong môi trường phát triển',
};


